/**
 * Temporal Awareness System
 *
 * Determines the current phase of day and adapts the interface accordingly.
 */

export function getTimePhase() {
  const h = new Date().getHours();
  if (h >= 6 && h < 11)  return 'morning';
  if (h >= 11 && h < 17) return 'afternoon';
  return 'evening';
}

export function getGreeting() {
  const phase = getTimePhase();
  if (phase === 'morning')   return 'Good morning';
  if (phase === 'afternoon') return 'Good afternoon';
  return 'Good evening';
}

export function getPhaseConfig(phase) {
  const configs = {
    morning: {
      heroContent: 'brief',
      bgVariant: 'morning',
      showMorningBrief: true,
      showDaySummary: false,
      showTomorrowPreview: false,
      label: 'Morning',
      accent: 'amber',
    },
    afternoon: {
      heroContent: 'now',
      bgVariant: 'neutral',
      showMorningBrief: false,
      showDaySummary: false,
      showTomorrowPreview: false,
      label: 'Afternoon',
      accent: 'blue',
    },
    evening: {
      heroContent: 'summary',
      bgVariant: 'evening',
      showMorningBrief: false,
      showDaySummary: true,
      showTomorrowPreview: true,
      label: 'Evening',
      accent: 'violet',
    },
  };
  return configs[phase] || configs.afternoon;
}

export function isFridayEvening() {
  const now = new Date();
  return now.getDay() === 5 && now.getHours() >= 17;
}
